export { NileSkeletonLoader } from './nile-skeleton-loader';

